import template from './passwordReset.html';

export default angular.module('eventix.passwordReset',[ ])
    .config(function($stateProvider) {
        $stateProvider.state('eventix.passwordReset', {
            url: '/passwordReset?email&token',
            views: {
                '@': {
                    controller: 'PasswordResetController as vm',
                    templateUrl: template,
                },
            },
            resolve: /*@ngInject*/{
            },
        });
    })
    .controller('PasswordResetController', function($state, UIMessages, $translate, $transition$, $http, Auth) {
        var vm = this;
        vm.newDashboardRoot = NEW_DASHBOARD_ROOT;
        vm.messages = UIMessages;
    }).name;

